<template lang="pug">
  .import-modal
    b-modal(id="import-modal", :title="title", size="lg", ok-variant="outline-primary", cancel-variant="link", ref="import-ref",  @ok="save()")
      b-overlay(:show="$store.getters.loading" size="sm", top)
        template(v-if="status=='import'")
            b-form(size="sm", autocomplete="off")
                .form-row()
                      .text-center                   
                        vue-dropzone(id="drop1" :options="dropOptions", @vdropzone-complete="complete", @vdropzone-sending="sending")
                        
        template(v-if="status=='mapping'")

            table.table
                tr(v-for="(v,k) in mapping")
                    td() {{k}}
                    td()
                      b-select(:options="expect_schema_options", v-model="mapping_new[k]")

           
        template(slot="modal-footer")
            
            //b-btn(variant="outline-secondary" @click="$refs.modal1.hide(false)") Close
            b-btn(variant="primary"  @click="save()")#project-modal-save {{ok_btn_text}}



</template>

<script>
// @ is an alias to /src
import { validationMixin } from 'vuelidate'
import vueDropzone from "vue2-dropzone"
import { required, minLength } from 'vuelidate/lib/validators'
import CountrySelect from '@/components/CountrySelect'
import UserMultiSelect from '@/components/UserMultiSelect'
import TopicKeywordSelect from '@/components/TopicKeywordSelect'
import Config from '@/config'
import Vue from 'vue'

export default {

  name: 'ImportModal',
  props: [],
  
  mixins: [
    validationMixin
  ],
  validations: {
    form: {
        name: {
            required,
            minLength: minLength(1)
        }
     
    }
  },

  data: function () {
    return {
        is_complete: false,
        uid: null,
        title: "Import CSV",
        form: {},
        mapping: {},
        mapping_new: {},
        status: "import",
        options: [],
        submitStatus: null,
        ok_btn_text: "Import",
        expect_schema: {"title": "Organization", "type": "object", "properties": {"_id": {"title": " Id", "type": "string"}, "_rev": {"title": " Rev", "type": "string"}, "created_at": {"title": "Created At", "type": "string", "format": "date-time"}, "updated_at": {"title": "Updated At", "type": "string", "format": "date-time"}, "deleted_at": {"title": "Deleted At", "type": "string", "format": "date-time"}, "relations": {"title": "Relations", "default": {}, "type": "object"}, "name": {"title": "Name", "type": "string"}, "org_types": {"title": "Org Types", "default": [], "type": "array", "items": {"type": "string"}}, "web_entity": {"title": "Web Entity", "type": "string"}, "doc_type": {"title": "Doc Type", "default": "Organization", "type": "string"}, "secondary_web_entities": {"title": "Secondary Web Entities", "default": [], "type": "array", "items": {}}, "is_startup_score": {"title": "Is Startup Score", "type": "number"}, "is_startup": {"title": "Is Startup", "default": false, "type": "boolean"}, "company_quality_score": {"title": "Company Quality Score", "type": "number"}, "registration_number": {"title": "Registration Number", "type": "string"}, "registration_office": {"title": "Registration Office", "type": "string"}, "registration_at": {"title": "Registration At", "type": "string", "format": "date-time"}, "registration_court_id": {"title": "Registration Court Id", "type": "string"}, "registration_subject": {"title": "Registration Subject", "type": "string"}, "share_capital": {"title": "Share Capital", "type": "number"}, "crunchbase_rank": {"title": "Crunchbase Rank", "type": "integer"}, "hy_rank": {"title": "Hy Rank", "type": "integer"}, "legal_name": {"title": "Legal Name", "type": "string"}, "alias_names": {"title": "Alias Names", "default": [], "type": "array", "items": {"type": "string"}}, "managing_directors": {"title": "Managing Directors", "default": [], "type": "array", "items": {"type": "string"}}, "short_description": {"title": "Short Description", "type": "string"}, "description": {"title": "Description", "type": "string"}, "sources": {"title": "Sources", "default": [], "type": "array", "items": {"type": "string"}}, "source_first_created_at": {"title": "Source First Created At", "type": "string", "format": "date-time"}, "investors": {"title": "Investors", "default": [], "type": "array", "items": {"type": "string"}}, "address": {"title": "Address", "type": "string"}, "city": {"title": "City", "type": "string"}, "region": {"title": "Region", "type": "string"}, "country_code": {"title": "Country Code", "type": "string"}, "state_code": {"title": "State Code", "type": "string"}, "tags": {"title": "Tags", "default": [], "type": "array", "items": {"type": "string"}}, "cb_url": {"title": "Cb Url", "type": "string"}, "total_funding_usd": {"title": "Total Funding Usd", "type": "number"}, "total_funding": {"title": "Total Funding", "type": "number"}, "total_funding_currency_code": {"title": "Total Funding Currency Code", "type": "string"}, "last_funding_on": {"title": "Last Funding On", "type": "string"}, "employee_count": {"title": "Employee Count", "type": "string"}, "founding_date": {"title": "Founding Date", "type": "string"}, "closed_on": {"title": "Closed On", "type": "string"}, "is_closed": {"title": "Is Closed", "default": false, "type": "boolean"}, "status": {"title": "Status", "default": "independent", "enum": ["independent", "acquired", "operating", "closed", "ipo"], "type": "string"}, "categories": {"title": "Categories", "default": [], "type": "array", "items": {"type": "string"}}, "crunchbase_category_list": {"title": "Crunchbase Category List", "default": [], "type": "array", "items": {"type": "string"}}, "crunchbase_category_groups_list": {"title": "Crunchbase Category Groups List", "default": [], "type": "array", "items": {"type": "string"}}, "logo_url": {"title": "Logo Url", "type": "string"}, "facebook_url": {"title": "Facebook Url", "type": "string"}, "twitter_url": {"title": "Twitter Url", "type": "string"}, "linkedin_url": {"title": "Linkedin Url", "type": "string"}, "stock_symbol": {"title": "Stock Symbol", "type": "string"}, "email": {"title": "Email", "type": "string"}, "location_lat": {"title": "Location Lat", "type": "number"}, "location_lon": {"title": "Location Lon", "type": "number"}, "homepage_url": {"title": "Homepage Url", "type": "string"}, "project_ids": {"title": "Project Ids", "type": "array", "items": {"type": "object"}}}},
        dropOptions: {
          dictDefaultMessage: "<i class='fas fa-paperclip'></i> Upload CSV",
          url: Config.config.base_host + "/imports/upload",
          maxFilesize: 200, // MB
          //headers: {'Authorization': 'Bearer ' + localStorage.getItem('id_token')},
          maxFiles: 1,
          thumbnailWidth: 0, // px
          thumbnailHeight: 0  ,
          addRemoveLinks: true
        }
    }
  },


  computed: {
    expect_schema_options: function() {
        return Object.keys(this.expect_schema.properties).map((k)=>{return {"text": this.expect_schema.properties[k].title, "value": k}});
    }
  },

  mounted: function() {
     this.uid = this._uid;
  },

  methods: {

    complete(e) {
      this.is_complete = true;
      this.$store.dispatch("stop_loading");
      let data = JSON.parse(e.xhr.responseText);
      this.import_job_id = data.import_job_id
      this.mapping = data.mapping;
      this.status = "mapping";
    },

     sending() {
      this.$store.dispatch("start_loading");
    },

    open(project) {
      this.status = "import";
      if(project) {
        this.form = JSON.parse(JSON.stringify(project));
        this.ok_btn_text = "Save";
        this.title = "Import data";
        this.form.project_id = this.$route.params.id
      } else  {
        this.form = {"description": "", "name": "", keywords: [], "project_id": this.$route.params.id};
      }
      
      this.$refs['import-ref'].show()
    },
    
    save() {
        let mapping = []
        this.$store.dispatch("start_loading");
        Object.keys(this.mapping_new).forEach((k)=> {
          let v = this.mapping_new[k];
          if(k && v) mapping.push({"type_name": "Organization", "field": {"original": k, "mapped_to": v}});
        });

        Vue.http.post(`${Config.config.base_host}/imports/${this.import_job_id}/mapping`, mapping).then((res) => {
          console.log(res);
          this.$store.dispatch("stop_loading");
          location.href="/inbox/main";
          location.reload();
        });
  
    },

    
  },

  components: {
    CountrySelect,
    UserMultiSelect,
    TopicKeywordSelect,
    vueDropzone
  }
}

</script>
<style lang="scss" scoped>
.collapsed  .when-opened,
:not(.collapsed) .when-closed {
  display: none;
}
</style>
